<template>
    <Sidebar />
    <Content class="analytics-product-content analytics-big-box">
        <div class="inner inner-box">
            <div style="height:calc(100% - 0px)">
                <AnalyticsHeader v-if="$store.state.user_data.merchant_account_id" :show_check_box="true" :data_statistic="data_statistic" @handleSortLink="sortLinkClick"/>
                
                <Scrollbar class="left" id="body">
                    <!-- 要在show_sortlink=true的狀況下，判定last_time要不要在取代他 -->
                    <ProductList id="scroll-left" :title="'All Products'" :is_loading="is_loading" :data="data_products"
                        :date_range="{ start_date:start_date, end_date:end_date}" :sort_index="product_list_sort_index"
                        @update-sort="getProductList" :is_loading_page="is_loading_products_page"
                        :show_sortlink="true" :data_statistic="data_statistic" 
                        @handleSortLink="sortLinkClick" :show_last_datetime="true" :init_sortlink="sortlink_data" :key="sortlink_data"/>
                </Scrollbar>
            </div>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import AnalyticsHeader from '@/components/analytics/AnalyticsHeader.vue';
import Button from '@/components/ui/Button.vue';
import Content from '@/components/ui/Content.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import ProductItem from '@/components/product/ProductItem.vue';
import ProductList from '@/components/product/ProductList.vue';
import formatMoney from '@/utils/formatMoney';
import moment from 'moment';
import { SwitchSort, handleMaxMinFun  } from '@/utils/SwitchFun';

export default {
    name: 'Analytics - Products',

    data() {
        return {
            start_date: moment().add(-30, 'days').toDate(),
            end_date: moment().add(-1, 'days').toDate(),
            is_loading: true,
            is_loading_products_page: false,
            is_loading_products: true,
            product_list_sort_index: 0,
            data_statistic: false,
            data_products: [],
            current_page: 1,
            last_page: 1,
            sort:{
                key:'views',
                val:'desc'
            },
            sortlink_data:0,
        }
    },

    components: {
        Sidebar,
        Scrollbar,
        AnalyticsHeader,
        Button,
        Content,
        SvgIcon,
        ProductItem,
        ProductList,
    },

    watch: {
        '$store.state.user_data.merchant_account_id': function (val) {
            this.startFunction();
        },
    },


    methods: {
        formatMoney: formatMoney,

        sortLinkClick(val){
            this.sortlink_data=val;
            this.getStatistic();
            this.getProductList();
        },

        getApiParamStr(api) {
            let s = moment(this.start_date).format('YYYY-MM-DD');
            let e = moment(this.end_date).format('YYYY-MM-DD');
            return `${api}?start_date=${s}&end_date=${e}`;
        },

        getStatistic() {
            if(this.$store.state.user_data.merchant_account_id){
                let api = `/analytics/merchant-account-statistic`;
                //因為不管如何我都要先知道有sortlink=1的時候有沒有資料，所以這邊強行都CALL 1，但顯示不顯示由前端操控
                api = this.getApiParamStr(api) +`&is_include_shortlink_data=1`;
                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    this.data_statistic = res.data.data;
                    // console.log(this.data_statistic)
                });
            }
        },

        getProductList(obj) {
            if(this.$store.state.user_data.merchant_account_id){
                this.is_loading = true;
                this.is_loading_products = true;
                if (document.getElementById('body'))
                    document.getElementById('body').scrollTop = document.getElementById('body').scrollTop - 50;
                let api = `/creator/product-list`;
                api = this.getApiParamStr(api) + `&page=${this.current_page}&sort_key=${this.sort.key}&sort_val=${this.sort.val}&is_include_shortlink_data=${this.sortlink_data}`;


                if (obj) {
                    this.product_list_sort_index = obj.type.id - 1;

                    let sw_val=SwitchSort(obj.type.id);
                    if(sw_val.key){
                        this.sort.key = sw_val.key;
                        this.sort.val = sw_val.val;
                    }
                    this.current_page=1;
                    let newApi = `/creator/product-list?start_date=${obj.date.start}&end_date=${obj.date.end}` + `&page=${this.current_page}&is_include_shortlink_data=${this.sortlink_data}`;
                    api = `${newApi}&sort_key=${this.sort.key}&sort_val=${this.sort.val}`;
                }

                if(this.current_page > 1 ) this.is_loading_products_page = true;
                // console.log('api:', api)
                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    if (this.current_page === 1)
                        this.data_products = res.data.data;
                    else
                        res.data.data.forEach(p => {
                            this.data_products.push(p);
                        });
                    // console.log(res.data.data)
                    this.current_page = Number(res.data.current_page);
                    this.last_page = Number(res.data.last_page);
                    this.$nextTick(() => {
                        this.is_loading_products = false;
                        this.is_loading = false;
                        this.is_loading_products_page = false;
                    })

                    // setTimeout(() => {
                    //     this.is_loading_products = false;
                    //     this.is_loading = false;
                    // }, 1000);
                });
            }
        },

        handleScroll() {
            let body = document.getElementById('body').scrollTop + 700;
            let scroll = document.getElementById('scroll-left').offsetHeight;
            // console.log(body)
            // console.log(scroll)

            if (body > scroll && !this.is_loading_products && this.current_page < this.last_page) {
                console.log('more')
                this.current_page++;
                this.getProductList();
            }
        },

        startFunction(){
            this.sortlink_data= this.$store.state.save_sortlink_data;
            let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
            this.start_date = checkTime[0];
            this.end_date= checkTime[1];
            this.getStatistic();
            this.getProductList();
        },
    },

    mounted() {
        if(!this.$store.state.user_data.permission_list.analytics.viewPerformanceSummaries.permission){
            this.$router.push('/creator/list');
            return;
        }
        this.startFunction();
        this.$store.state.creator_data=null;

        this.EventBus.off('update-date');
        this.EventBus.on('update-date', (obj) => {
            this.start_date = obj.start_date;
            this.end_date = obj.end_date;
            this.current_page=1;

            setTimeout(() => {
                this.getStatistic();
                this.getProductList();
            }, 10);
        });

        document.getElementById('body').addEventListener('scroll', this.handleScroll);
    },

    destroyed() {
        document.getElementById('body').removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss">
.analytics-product-content {
    .inner {
        height: 100%;
        padding: 24px 48px;//24px 24px 0 24px;

        .list-header{
            .ui-dropdown{
                margin-right: 0;
            }
        }

        .left {
            width: 100%;
            //min-width: 600px;
            padding-bottom: 24px;
            overflow-x: hidden;
            height: calc(100% - 64px);

            .product-list {
                margin-top: 36px;
            }
        }

    }
}</style>